import { createCollection } from './collection';
import { db } from './db';

export { createCollection, db };
